// extracted by mini-css-extract-plugin
module.exports = {"shopifyRedirectionWrapper":"ShopifyRedirection_shopifyRedirectionWrapper__1t-iL","title":"ShopifyRedirection_title__1folw"};